import * as React from "react";
const SvgShoePrints = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M13 0C16 0 20 1.5 20 4C20 6.5 16.25 7 14.5 7C13 7 12.125 6.5 11.25 6C10.375 5.5 9.5 5 8 5V1C8 1 11 0 13 0ZM4 3C4 1.90625 4.875 1 6 1H7V5H6C4.875 5 4 4.125 4 3ZM9 16C7 16 4 15 4 15V11C5.5 11 6.375 10.5 7.25 10C8.125 9.5 9 9 10.5 9C12.25 9 16 9.5 16 12C16 14.5 12 16 9 16ZM0 13C0 11.9062 0.875 11 2 11H3V15H2C0.875 15 0 14.125 0 13Z",
	fill: "#161616"
}));
export default SvgShoePrints;
